import * as React from 'react'

type Props = React.SVGProps<SVGSVGElement> & {
    title?: string
    titleId?: string
}

const Grid4 = React.forwardRef<SVGSVGElement, Props>(
    ({ title, titleId, ...props }, ref) => {
        const ariaProps = title
            ? { role: 'img', 'aria-labelledby': titleId || 'grid4-title' }
            : { 'aria-hidden': true }

        return (
            <svg
                ref={ref}
                width="1em"
                height="1em"
                viewBox="0 0 66 32"
                xmlns="http://www.w3.org/2000/svg"
                {...ariaProps}
                {...props}
            >
                {title ? (
                    <title id={titleId || 'grid4-title'}>{title}</title>
                ) : null}
                <rect
                    x="34.2207"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="34.2207"
                    y="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="34.2207"
                    y="23.0444"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="45.7432"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="45.7432"
                    y="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="45.7432"
                    y="23.0444"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="57.2651"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="57.2651"
                    y="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="57.2651"
                    y="23.0444"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect width="8.64165" height="8.64165" fill="currentColor" />
                <rect
                    y="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    y="23.0444"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="11.522"
                    y="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="11.522"
                    y="23.0444"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="23.0439"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="23.0439"
                    y="11.522"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
                <rect
                    x="23.0439"
                    y="23.0444"
                    width="8.64165"
                    height="8.64165"
                    fill="currentColor"
                />
            </svg>
        )
    }
)

Grid4.displayName = 'Grid4'
export default React.memo(Grid4)
